// Enums for the application - separated to avoid circular imports

export enum UserRole {
  ADMINISTRADOR = 'Administrador',
  EDITOR = 'Editor',
  VISUALIZADOR = 'Visualizador',
}

export enum PermissionResource {
  USERS = 'users',
  ROLES = 'roles',
  SOLICITUDES = 'solicitudes',
  POSTULACIONES = 'postulaciones',
  REPORTS = 'reports',
}

export enum PermissionAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  EVALUATE = 'evaluate',
  UPDATE_STATUS = 'update_status',
  VIEW = 'view',
  EXPORT = 'export',
  QUALIFY = 'qualify',
  BULK_QUALIFY = 'bulk_qualify',
}

export enum UserManagementError {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  INVALID_ROLE = 'INVALID_ROLE',
  CANNOT_DELETE_SELF = 'CANNOT_DELETE_SELF',
  CANNOT_DELETE_LAST_ADMIN = 'CANNOT_DELETE_LAST_ADMIN',
  ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
  CANNOT_DELETE_SYSTEM_ROLE = 'CANNOT_DELETE_SYSTEM_ROLE',
  ROLE_HAS_USERS = 'ROLE_HAS_USERS',
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
}

export enum JobDefinitionError {
  NOT_FOUND = 'JD_NOT_FOUND',
  DUPLICATE_NAME = 'JD_DUPLICATE_NAME',
  INVALID_OCUPABILIDAD = 'JD_INVALID_OCUPABILIDAD',
  REFERENCED_BY_SOLICITUDES = 'JD_REFERENCED',
  PERMISSION_DENIED = 'JD_PERMISSION_DENIED',
  VERSION_CONFLICT = 'JD_VERSION_CONFLICT',
  INVALID_DATA = 'JD_INVALID_DATA',
  CREATION_FAILED = 'JD_CREATION_FAILED',
  UPDATE_FAILED = 'JD_UPDATE_FAILED',
  DELETE_FAILED = 'JD_DELETE_FAILED',
}

export enum QualificationStatus {
  PENDIENTE = 'pendiente',
  CALIFICA = 'califica',
  NO_CALIFICA = 'no_califica',
}
